import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { AvailabilitySlot, CONTACT_TYPE_LABELS, CONTACT_TYPE_COLORS } from '../availability-schedules.model';
import { parseTimeFromRange } from './calendarUtils';

interface ProviderSlotProps {
  slot: AvailabilitySlot;
}

const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName?.charAt(0) || '';
  const last = lastName?.charAt(0) || '';
  return `${first}${last}`.toUpperCase();
};

const ProviderSlot: React.FC<ProviderSlotProps> = ({ slot }) => {
  const contactType = CONTACT_TYPE_LABELS[slot.contact_type_id ?? 0] || 'Any';
  const color = CONTACT_TYPE_COLORS[slot.contact_type_id ?? 0] || '#9E9E9E';
  const { startTime, endTime } = parseTimeFromRange(slot.range_start, slot.range_end);

  const tooltipContent = `${slot.provider_name} · ${contactType} · ${startTime}–${endTime}`;

  return (
    <Tooltip title={tooltipContent} arrow placement="top">
      <Chip
        label={getInitials(slot.first_name, slot.last_name)}
        size="small"
        sx={{
          backgroundColor: color,
          color: '#fff',
          fontSize: '0.65rem',
          fontWeight: 600,
          height: 22,
          mr: 0.25,
          mb: 0.25,
          cursor: 'default',
        }}
      />
    </Tooltip>
  );
};

export default ProviderSlot;
